import { render, staticRenderFns } from "./PostRegistrationPopup.vue?vue&type=template&id=6a26f35a&scoped=true&"
import script from "./PostRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./PostRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./PostRegistrationPopup.vue?vue&type=style&index=0&id=6a26f35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26f35a",
  null
  
)

export default component.exports